import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted, onUnmounted, Ref, ComputedRef, watch, nextTick, computed ,onBeforeUnmount} from 'vue';
import TUIRoomCore, {
  TRTCVideoResolution,
  ETUIRoomEvents,
  TRTCVideoResolutionMode,
  ETUIStreamType,
  TRTCVideoEncParam,
} from '../../tui-room-core';
import { storeToRefs } from 'pinia';
import { StreamInfo, useRoomStore } from '../../../stores/room';
import { useBasicStore } from '../../../stores/basic';
import { useChatStore } from '../../../stores/chat';
import { LAYOUT } from '../../../constants/render';
import RoomFooter from '../../components/RoomFooter/index.vue';
import StreamRegion from './StreamRegion.vue';
import {USER_ROLE_MAJOR} from "@/constants/localKeys"
import SvgIcon from '../common/SvgIcon.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'StreamContainer',
  props: {
    showRoomTool: { type: Boolean }
  },
  emits: ['on-destroy-room', 'on-exit-room'],
  setup(__props: any, { emit }) {


const chatStore = useChatStore();
const streamStyle: Ref<Record<string, any>> = ref({ width: '0', height: '0'});
const enlargedStreamStyle: Ref<Record<string, any>> = ref({ width: '0', height: '0' });
const roomStore = useRoomStore();
const { streamList, streamNumber } = storeToRefs(roomStore);
const basicStore = useBasicStore();
const { layout,userRole } = storeToRefs(basicStore);
const showSideList = ref(true);


const enlargeStream: Ref<StreamInfo | null> = ref(null);
const enlargeDomId = computed(() => (enlargeStream.value ? `${enlargeStream.value.userId}_${enlargeStream.value.type}` : ''));

//todo
console.log('----------streamList 有成员加入房间----------------------------')
console.log(streamList)
console.log(showSideList.value);

// ----- 以下处理九宫格翻页逻辑 -----
const currentPageIndex = ref(0);
const showStreamList: ComputedRef<StreamInfo[]> = computed(() => {
  if (layout.value !== LAYOUT.NINE_EQUAL_POINTS) {
    return streamList.value;
  }
  return streamList.value.slice(currentPageIndex.value * 9, currentPageIndex.value * 9 + 9);
});

// 显示左右翻页图标
const showTurnPageControl = computed(() => layout.value === LAYOUT.NINE_EQUAL_POINTS && streamNumber.value > 9);
// 是否展示九宫格朝左翻页按钮
const showTurnPageLeftArrow = computed(() => currentPageIndex.value > 0);
// 是否展示九宫格朝右翻页按钮
const showTurnPageRightArrow = computed(() => streamNumber.value > currentPageIndex.value * 9 + 9);

// 九宫格布局朝左翻页
function handleTurnPageLeft() {
  currentPageIndex.value = currentPageIndex.value - 1;
  handleNineEqualPointsLayout();
}

// 九宫格布局朝右翻页
function handleTurnPageRight() {
  currentPageIndex.value = currentPageIndex.value + 1;
  handleNineEqualPointsLayout();
}

// ----- 以下处理流布局 ---------
const streamContainerClass = ref('');
const enlargedContainerRef = ref();
const streamListRef = ref();

const arrowClass = computed(() => {
  let arrowDirection = '';
  if (layout.value === LAYOUT.TOP_SIDE_LIST) {
    arrowDirection = showSideList.value ? 'up' : 'down';
  }
  if (layout.value === LAYOUT.RIGHT_SIDE_LIST) {
    arrowDirection = showSideList.value ? 'right' : 'left';
  }
  return `icon-control arrow-${arrowDirection}`;
});

function handleClickIcon() {
  showSideList.value = !showSideList.value;
  if (!showSideList.value) {
    let width = 0;
    let height = 0;
    const containerWidth = document.getElementById('roomContainer')!.offsetWidth;
    const containerHeight = document.getElementById('roomContainer')!.offsetHeight;
    const scaleWidth = containerWidth / 16;
    const scaleHeight = containerHeight / 9;
    if (scaleWidth > scaleHeight) {
      width = (containerHeight / 9) * 16;
      height = containerHeight;
    }
    if (scaleWidth < scaleHeight) {
      width = containerWidth;
      height = (containerWidth / 16) * 9;
    }
    enlargedStreamStyle.value.width = `${width}px`;
    enlargedStreamStyle.value.height = `${height}px`;
    // 修改 enlargedContainer 的宽和高
    if (layout.value === LAYOUT.RIGHT_SIDE_LIST) {
      enlargedContainerRef.value.style.width = '100%';
      enlargedContainerRef.value.style.height = '100%';
      return;
    }
    if (layout.value === LAYOUT.TOP_SIDE_LIST) {
      enlargedContainerRef.value.style.top = '0px';
      enlargedContainerRef.value.style.width = '100%';
      enlargedContainerRef.value.style.height = '100%';
      return;
    }
  } else {
    if (layout.value  === LAYOUT.RIGHT_SIDE_LIST) {
      handleRightSideListLayout();
      enlargedContainerRef.value.style.width = 'calc(100% - 260px)';
      enlargedContainerRef.value.style.height = '100%';
      return;
    }
    if (layout.value === LAYOUT.TOP_SIDE_LIST) {
      handleTopSideListLayout();
      enlargedContainerRef.value.style.top = '165px';
      enlargedContainerRef.value.style.width = '100%';
      enlargedContainerRef.value.style.height = 'calc(100% - 175px)';
      return;
    }
  }
}

// 处理九宫格布局
async function handleNineEqualPointsLayout() {
  streamContainerClass.value = 'stream-container-flatten';

  enlargeStream.value = null;
  await nextTick();

  const number = showStreamList.value.length;
  let width = 0;
  let height = 0;
  const roomContainerElement = document.getElementById('roomContainer');
  let containerWidth = roomContainerElement!.offsetWidth;
  let containerHeight = roomContainerElement!.offsetHeight;
  if (number <= 4) {
    containerWidth = number < 2 ? roomContainerElement!.offsetWidth / number : roomContainerElement!.offsetWidth / 2;
    containerHeight = roomContainerElement!.offsetHeight / Math.ceil(number / 2);
  } else if (number > 4) {
    containerWidth = number < 3 ? roomContainerElement!.offsetWidth / number : roomContainerElement!.offsetWidth / 3;
    containerHeight = roomContainerElement!.offsetHeight / Math.ceil(number / 3);
  }

  const scaleWidth = containerWidth / 16;
  const scaleHeight = containerHeight / 9;
  if (scaleWidth > scaleHeight) {
    width = (containerHeight / 9) * 16;
    height = containerHeight;
  }
  if (scaleWidth <= scaleHeight) {
    width = containerWidth;
    height = (containerWidth / 16) * 9;
  }
  streamStyle.value.width = `${width}px`;
  streamStyle.value.height = `${height}px`;
}

// 处理侧边栏布局
async function handleRightSideListLayout() {
  streamContainerClass.value = 'stream-container-right';

  if (!enlargeStream.value) {
    [enlargeStream.value] = streamList.value;
  }

  await nextTick();
  streamStyle.value = {};

  if (enlargedContainerRef.value) {
    const containerWidth = enlargedContainerRef.value.offsetWidth;
    const containerHeight = enlargedContainerRef.value.offsetHeight;
    let width = 0;
    let height = 0;
    const scaleWidth = containerWidth / 16;
    const scaleHeight = containerHeight / 9;
    if (scaleWidth > scaleHeight) {
      width = (containerHeight / 9) * 16;
      height = containerHeight;
    }
    if (scaleWidth < scaleHeight) {
      width = containerWidth;
      height = (containerWidth / 16) * 9;
    }
    enlargedStreamStyle.value.width = `${width}px`;
    enlargedStreamStyle.value.height = `${height}px`;
  }
}

// 处理顶部栏布局
async function handleTopSideListLayout() {
  streamContainerClass.value = 'stream-container-top';

  if (!enlargeStream.value) {
    [enlargeStream.value] = streamList.value;
  }

  await nextTick();
  streamStyle.value = {};

  if (enlargedContainerRef.value) {
    const containerWidth = enlargedContainerRef.value.offsetWidth;
    const containerHeight = enlargedContainerRef.value.offsetHeight;
    let width = 0;
    let height = 0;
    const scaleWidth = containerWidth / 16;
    const scaleHeight = containerHeight / 9;
    if (scaleWidth > scaleHeight) {
      width = (containerHeight / 9) * 16;
      height = containerHeight;
    }
    if (scaleWidth < scaleHeight) {
      width = containerWidth;
      height = (containerWidth / 16) * 9;
    }
    enlargedStreamStyle.value.width = `${width}px`;
    enlargedStreamStyle.value.height = `${height}px`;
  }
}

function handleEnlargeStreamRegion(stream: StreamInfo) {
  if (layout.value === LAYOUT.NINE_EQUAL_POINTS) {
    return;
  }
  enlargeStream.value = stream;
}

// 页面加载或者 layout 改变时，处理页面布局
function handleLayout() {
  switch (layout.value as any) {
    case LAYOUT.NINE_EQUAL_POINTS:
      handleNineEqualPointsLayout();
      break;
    case LAYOUT.RIGHT_SIDE_LIST:
      showSideList.value = true;
      enlargedContainerRef.value.style.width = 'calc(100% - 260px)';
      enlargedContainerRef.value.style.height = '100%';
      handleRightSideListLayout();
      break;
    case LAYOUT.TOP_SIDE_LIST:
      if (userRole.value == USER_ROLE_MAJOR){
        showSideList.value = true;
      }else{
        // showSideList.value = false;
      }
      enlargedContainerRef.value.style.width = '100%';
      enlargedContainerRef.value.style.height = 'calc(100% - 175px)';
      enlargedContainerRef.value.style.height = '100%';
      handleTopSideListLayout();
      break;
    default:
      break;
  }
}

// 页面 resize 时，处理流窗口尺寸
function handleResize() {
  switch (layout.value as any) {
    case LAYOUT.NINE_EQUAL_POINTS:
      handleNineEqualPointsLayout();
      break;
    case LAYOUT.RIGHT_SIDE_LIST:
      handleRightSideListLayout();
      break;
    case LAYOUT.TOP_SIDE_LIST:
      handleTopSideListLayout();
      break;
    default:
      break;
  }
}
function resetStore() {
  basicStore.reset();
  chatStore.reset();
  roomStore.reset();
}
const onDestroyRoom = (info: { code: number; message: string, data:any }) => {
  resetStore();
  emit('on-destroy-room', info);
};

const onExitRoom = (info: { code: number; message: string, data:any }) => {
  resetStore();
  emit('on-exit-room', info);
};
onMounted(() => {
  handleLayout();
  ['resize', 'pageshow'].forEach((event) => {
    window.addEventListener(event, handleResize);
  });
});

onUnmounted(() => {
  ['resize', 'pageshow'].forEach((event) => {
    window.removeEventListener(event, handleResize);
  });
});

watch(streamNumber, (val) => {
  console.log('结束的时候这里有监听吗-------------------------')
  if (streamNumber.value > 1){
    showSideList.value = true;
    basicStore.setLayout(LAYOUT.TOP_SIDE_LIST);
  }else{
    basicStore.setLayout(LAYOUT.NINE_EQUAL_POINTS);
    if (currentPageIndex.value > Math.ceil(val / 9) - 1) {
      currentPageIndex.value = Math.ceil(val / 9) - 1;
      handleNineEqualPointsLayout();
    }
  }
});

watch(layout, () => {
  handleLayout();
});

const showIconControl = computed(() => [LAYOUT.RIGHT_SIDE_LIST, LAYOUT.TOP_SIDE_LIST].indexOf(layout.value) >= 0);
// --- 以下处理流事件 ----

const onUserEnterRoom = (streamInfo: any) => {
  console.log("开始的时候添加用户---------------------------onUserEnterRoom")
  roomStore.addRemoteUser(streamInfo);
};

const onUserLeaveRoom = (streamInfo: { userId: string }) => {
  console.log("结束直播的时候 销毁用户------------------")
  roomStore.removeRemoteUser(streamInfo.userId);
};

// 收到远端 trtc 的 peer-join 事件  todo 加入
const onUserAVEnabled = (userInfo: any) => {
  console.log("-----的 peer-join 事件  todo 加入-----")
  roomStore.updateUserAVAbility(userInfo, true);
};

// 收到远端 trtc 的 peer-leave 事件   todo 离开
const onUserAVDisabled = (userInfo: any) => {
  console.log('---------的 peer-leave 事件   todo 离开--------');
  roomStore.updateUserAVAbility(userInfo, false);
  if (userInfo.userId === enlargeStream.value?.userId || roomStore.remoteStreamList.length === 0) {
    if (streamNumber.value > 1){
      basicStore.setLayout(LAYOUT.TOP_SIDE_LIST);
    }else{
      basicStore.setLayout(LAYOUT.NINE_EQUAL_POINTS);
    }
    enlargeStream.value = null;
  }
};

const onUserVideoAvailable = (eventInfo: { userId: string, available: number, streamType: number }) => {
  const { userId, available, streamType } = eventInfo;
  console.log("------------onUserVideoAvailable---------")
  console.log(eventInfo)
  if (userId === basicStore.userId) {
    roomStore.updateLocalStream({ isVideoStreamAvailable: !!available });
    return;
  }

  if (streamType === ETUIStreamType.CAMERA) {
    roomStore.updateRemoteVideoStream(eventInfo);
    /**
     * 处理 web 端屏幕分享】
     **/
    if (userId.indexOf('share_') === 0 && userId !== `share_${basicStore.userId}`) {
      enlargeStream.value = roomStore.remoteStreamObj[`${userId}_main`] as StreamInfo;
      if (layout.value !== LAYOUT.NINE_EQUAL_POINTS && layout.value !== LAYOUT.TOP_SIDE_LIST) {
        basicStore.setLayout(LAYOUT.TOP_SIDE_LIST);
      }
      return;
    }

    /**
     * 当远端流视频位 available 为 true，主持人端修改该用户的禁画提示为【禁画】
     **/
    if (basicStore.isMaster && available) {
      roomStore.setMuteUserVideo(userId, false);
    }
  } else if (streamType === ETUIStreamType.SCREEN) {
    roomStore.updateRemoteScreenStream(eventInfo);
    if (available) {
        enlargeStream.value = roomStore.remoteStreamObj[`${userId}_screen`] as StreamInfo;
        // 处理 web 端屏幕分享
        if (layout.value !== LAYOUT.NINE_EQUAL_POINTS && layout.value !== LAYOUT.TOP_SIDE_LIST) {
            basicStore.setLayout(LAYOUT.TOP_SIDE_LIST);
        }
    } else {
      /**
       * 远端屏幕分享流停止的时候，重新设置流播放布局
       **/
      if (roomStore.remoteStreamList.length === 0) {
        basicStore.setLayout(LAYOUT.TOP_SIDE_LIST);
        enlargeStream.value = null;
      } else if (userId === enlargeStream.value?.userId) {
        [enlargeStream.value] = roomStore.remoteStreamList;
      }
    }
  }
};


const onUserAudioAvailable = (eventInfo: { userId: string, available: number}) => {
  const { userId, available } = eventInfo;
  if (userId === basicStore.userId) {
    roomStore.updateLocalStream({ isAudioStreamAvailable: !!available });
    return;
  }
  roomStore.updateRemoteAudioStream(eventInfo);
  // 当远端流音频位 available 为 true，主持人端修改该用户的禁画提示为【禁言】
  if (basicStore.isMaster && available) {
    roomStore.setMuteUserAudio(userId, false);
  }
};

const { isDefaultOpenCamera, isDefaultOpenMicrophone } = storeToRefs(roomStore);
const { isLocalAudioIconDisable, isLocalVideoIconDisable } = storeToRefs(basicStore);

watch(isDefaultOpenCamera, async (val) => {
  if (val && !isLocalVideoIconDisable.value) {
    const previewDom = document.getElementById(`${roomStore.localStream.userId}_main`);
    if (previewDom) {
      // 设置设备id
      if (!roomStore.currentCameraId) {
        const cameraList = await TUIRoomCore.getCameraList();
        roomStore.setCurrentCameraId(cameraList[0].deviceId);
      }
      await TUIRoomCore.setCurrentCamera(roomStore.currentCameraId);
      // 设置视频参数
      const param = new TRTCVideoEncParam();
      // param.videoResolution = TRTCVideoResolution.TRTCVideoResolution_1920_1080;
      param.resMode = TRTCVideoResolutionMode.TRTCVideoResolutionModeLandscape;
      param.minVideoBitrate = 0;
      param.enableAdjustRes = true;
      TUIRoomCore.setVideoEncoderParam(param);
      // 开启本地摄像头
      await TUIRoomCore.startCameraPreview(previewDom);
      roomStore.setHasStartedCamera(true);
    }
  }
});

watch(isDefaultOpenMicrophone, async (val) => {
  if (val && !isLocalAudioIconDisable.value) {
    // 提前 startMicrophone 的时机，保证在 startCameraPreview 之前执行
    await TUIRoomCore.startMicrophone();
    roomStore.setHasStartedMicrophone(true);
    const microphoneList = await TUIRoomCore.getMicrophoneList();
    if (!roomStore.currentMicrophoneId) {
      roomStore.setCurrentMicrophoneId(microphoneList[0].deviceId);
    }
    if (!roomStore.currentSpeakerId) {
      roomStore.setCurrentSpeakerId(microphoneList[0].deviceId);
    }
    await TUIRoomCore.setCurrentMicrophone(roomStore.currentMicrophoneId);
  }
});
const shows=ref(false)

async function onGrantAnchor(event:any) {
  if (event.mute){
    shows.value=true
    }else{
      shows.value=false
    }
}

onMounted(async () => {
  TUIRoomCore.on(ETUIRoomEvents.onUserEnterRoom, onUserEnterRoom);
  TUIRoomCore.on(ETUIRoomEvents.onUserLeaveRoom, onUserLeaveRoom);
  TUIRoomCore.on(ETUIRoomEvents.onUserAVEnabled, onUserAVEnabled);
  TUIRoomCore.on(ETUIRoomEvents.onUserAVDisabled, onUserAVDisabled);
  TUIRoomCore.on(ETUIRoomEvents.onUserVideoAvailable, onUserVideoAvailable);
  TUIRoomCore.on(ETUIRoomEvents.onUserAudioAvailable, onUserAudioAvailable);
  TUIRoomCore.on(ETUIRoomEvents.onGrantAnchor, onGrantAnchor);
});
onBeforeUnmount(() => {
  TUIRoomCore.off(ETUIRoomEvents.onGrantAnchor, onGrantAnchor)
});
onUnmounted(() => {
  TUIRoomCore.off(ETUIRoomEvents.onUserEnterRoom, onUserEnterRoom);
  TUIRoomCore.off(ETUIRoomEvents.onUserLeaveRoom, onUserLeaveRoom);
  TUIRoomCore.off(ETUIRoomEvents.onUserAVEnabled, onUserAVEnabled);
  TUIRoomCore.off(ETUIRoomEvents.onUserAVDisabled, onUserAVDisabled);
  TUIRoomCore.off(ETUIRoomEvents.onUserVideoAvailable, onUserVideoAvailable);
  TUIRoomCore.off(ETUIRoomEvents.onUserAudioAvailable, onUserAudioAvailable);
});

return { __sfc: true,chatStore, streamStyle, enlargedStreamStyle, roomStore, streamList, streamNumber, basicStore, layout, userRole, showSideList, emit, enlargeStream, enlargeDomId, currentPageIndex, showStreamList, showTurnPageControl, showTurnPageLeftArrow, showTurnPageRightArrow, handleTurnPageLeft, handleTurnPageRight, streamContainerClass, enlargedContainerRef, streamListRef, arrowClass, handleClickIcon, handleNineEqualPointsLayout, handleRightSideListLayout, handleTopSideListLayout, handleEnlargeStreamRegion, handleLayout, handleResize, resetStore, onDestroyRoom, onExitRoom, showIconControl, onUserEnterRoom, onUserLeaveRoom, onUserAVEnabled, onUserAVDisabled, onUserVideoAvailable, onUserAudioAvailable, isDefaultOpenCamera, isDefaultOpenMicrophone, isLocalAudioIconDisable, isLocalVideoIconDisable, shows, onGrantAnchor, RoomFooter, StreamRegion, SvgIcon }
}

})